
<template>
  <Loader v-if="loader" />

  <div class="card">
    <div class="formgrid grid ">
        <div class="field col-12 md:col-3">
            <label>Tipo fornitura</label>
            <Dropdown v-model="selectedTipoFornitura" :options="typesFornitura"  :class="['inputfield w-full',{'p-invalid': validationErrors.typeFornitura && submitted}]" />
            <div v-show="validationErrors.typeFornitura && submitted" class="p-error">Seleziona campo.</div>
        </div>
        <div class="field col-12 md:col-3">
            <label>Su base</label>
            <Dropdown v-model="selectedTipo" :options="types"  :class="['inputfield w-full',{'p-invalid': validationErrors.type && submitted}]" />
            <div v-show="validationErrors.type && submitted" class="p-error">Seleziona campo.</div>
        </div>
        <div class="field col-12 md:col-3">
            <label>Data</label>
            <Calendar v-model="date" :showIcon="true" view="month" dateFormat="mm-yy" :class="['inputfield w-full',{'p-invalid': validationErrors.date && submitted}]" />
            <div v-show="validationErrors.date && submitted" class="p-error">Seleziona data.</div>
        </div>
        <!-- <div class="field col-12 md:col-3">
            <label>Rappresentante</label>
            <Dropdown v-model="selectedRappresentante" :options=" rappresentanti" optionLabel="name" optionValue="id" :filter="true" dataKey="id"  class="inputfield w-full" />
        </div> -->
        <div class="field col-12 md:col-3 flex align-items-end justify-content-center">
            <Button label="Cerca" icon="pi pi-search" iconPos="left" class="w-full" @click="searchData" />
        </div>
    </div>
  </div>

  
  <TabView lazy v-model:activeIndex="activeTabIndex">
    <TabPanel v-for="tab in tabs" :key="tab.title">
      <template v-if="tab" #header>
          <span>{{tab.title}}</span>
          <div class="badge">
              {{tab.data.length}} <small class="ml-1">su {{tab.total}}</small> 
          </div>             
      </template>

      <DataTable :ref="`dt_${activeTabIndex}`" :value="tab.data" :paginator="true" :rows="10" :filters="filters" exportFilename="acquisto-vendita"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10,20,50]" responsiveLayout="scroll"
          currentPageReportTemplate="{first} a {last} di {totalRecords}">
          <template #header>
            <div class="flex justify-content-between flex-wrap">
                <div class="flex align-items-center justify-content-center mb-2">
                   <span class="p-input-icon-left">
                      <i class="pi pi-search" />
                      <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
                  </span>
                </div>
                <div class="flex align-items-center justify-content-center">
                   <Button icon="pi pi-download" label="Esporta" @click="exportCSV(activeTabIndex)" class="p-button-secondary" />
                </div>
            </div>
          </template>

         <template #empty>
              <div class="text-center">Nessun dato trovato.</div>
          </template> 
          <Column field="fornitura_code" header="Fornitura" :sortable="true">
            <template #body="{data}">
              <p>
                <router-link :to="`/ask/${selectedTipoFornitura}s/${data.id}/dettagli`" target="_blank">
                  {{data.fornitura_code}}
                </router-link>
              </p>
            </template>
          </Column>
          <Column field="cliente" header="Cliente" :sortable="true"></Column>
          <Column field="rappresentante" header="Rappresentante" :sortable="true"></Column>
          <Column field="fornitore" header="Fornitore" :sortable="true"></Column>
          <Column  field="cod_type_periodo" header="Fatturazione" :sortable="true">
            <template #body="{data}" >
              {{data.cod_type_periodo ==  2 ? 'Bimestrale' : 'Mensile'}}    
            </template>
          </Column>
      </DataTable>
      
    </TabPanel>
  </TabView>




</template>

<script>
import moment from 'moment'
import Service from '@/services/ask-pratiche/pratiche-service'
import { ref, onMounted, getCurrentInstance  } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import Loader from '@/components/Loader.vue'


export default {
    components: {
      Loader
    },
    setup() {

      const dt = ref();
      const loader = ref(false)
      const activeTabIndex = ref(0);
      const tabs = ref();
      const typesFornitura = ref(['pod','pdr']);
      const types = ref(['Fatturazione','Rcu']);
      const selectedTipoFornitura = ref();
      const selectedTipo = ref();
      const filters = ref({
          'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      });
      const self = getCurrentInstance();
      self.$eventBus = self.appContext.config.globalProperties.$eventBus
      self.$http = self.appContext.config.globalProperties.$http
      const service = new Service(self.$http, self.$eventBus)
      const date = ref();
      // const rappresentanti = ref([])
      // const selectedRappresentante = ref(0)
      const validationErrors = ref({})
      const submitted = ref(false)

      onMounted(() => {       

      })
      const searchData = () => {
        submitted.value = true;
        if (validateData()) {
          loader.value = true
          service.getControlloAcquistatoVendutoFornitori(
            moment(date.value).format('YYYY-MM-DD'),
            selectedTipo.value,
            selectedTipoFornitura.value,
            // selectedRappresentante.value
          ).then((res) => {
            tabs.value = res.items
            console.log(tabs.value)
          }).finally(() => {
              loader.value = false
          })
        }
      }

      // service.getRappresentanti().then((res) => {
      //   rappresentanti.value = res.items
      // })



      const exportCSV = (index) => {
        self.refs[`dt_${index}`].exportCSV()
      };

      const validateData = () =>{
        if (date.value == null)
          validationErrors.value['date'] = true;
        else 
          delete validationErrors.value['date'];
        
        if (selectedTipo.value == null)
          validationErrors.value['type'] = true;
        else 
          delete validationErrors.value['type'];

        if (selectedTipoFornitura.value == null)
          validationErrors.value['typeFornitura'] = true;
        else 
          delete validationErrors.value['typeFornitura'];
    
        return !Object.keys(validationErrors.value).length;
      }


      return { 
        dt,
        tabs,
        // rappresentanti,
        // selectedRappresentante,
        activeTabIndex,
        typesFornitura,
        types,
        selectedTipoFornitura,
        selectedTipo,
        loader, 
        filters, 
        date,
        searchData,
        exportCSV,
        validationErrors,
        submitted,
        
      }
  }
}
</script>


<style scoped>
.badge {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    color: var(--primary-color);
    background-color: rgb(184, 229, 253);
    padding: 4px 7px;
    margin-left: 6px;
    border-radius: 3px;
}

</style>

